/* eslint-disable react/button-has-type */
import React from 'react';
import PropTypes from 'prop-types';
// import { Modal, Box } from '@material-ui/core';
import { Modal, Box } from '@mui/material';
import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb';
import styles from './FormComponents.module.css';
import CloseIcon from '@mui/icons-material/Close';
import clsx from 'clsx';
const title2 = {
    errorMessageData: [
        {
            name: "name",
            message: "message",
        },
        {
            name: "name",
            message: "message",
        },
        {
            name: "name",
            message: "message",
        },
        {
            name: "name",
            message: "message",
        },
        {
            name: "name",
            message: "message",
        },
        {
            name: "name",
            message: "message",
        },
        {
            name: "name",
            message: "message",
        },
        {
            name: "name",
            message: "message",
        },
    ]
}
const FormModal = ({ handleClose, open, title, buttonEnable, confirmButton, confirmTitle }) => (
    // console.log("ddffdf = ",title)
    <Modal open={open} onClose={handleClose}>
        <div className={styles.container}>
            <div className={clsx(styles.title, "largeFont")}>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <DoNotDisturbIcon className={styles.block} fontSize="1rem" />
                    <span className={styles.txt}>{title.totalData != 1 ? "Delete Errors" : "Delete Error"}</span><span className={styles.txt}>{title.totalData != 1 ? title.failedData + " Out of " + title.totalData + " !" : null}</span>
                </div>
                <CloseIcon className={styles.crossBlock} onClick={handleClose} />
            </div>
            <Box bgcolor="#dadada3d" padding="13px" backgroundColor="#fff">
                <div>
                    <span className="largeFont" style={{ margin: "0 0 10px 0", color: "#FFA222" }}> Following are the reason ? </span>
                </div>
                <div style={{ backgroundColor: "#dadada3d", height: "75px", margin: "10px 0 0 0", padding: "10px 0 0 20px", overflow: "scroll", display: "flex", flexDirection: "column", gap: ".5rem" }}>
                    {
                        // console.log("insidd = ",title,)
                        title.errorMessageData.map((item) => {
                            return (
                                <>
                                    <div style={{ display: "flex", flexDirection: "column", justifyContent: "center" }}>
                                        <span className={clsx(styles.formText, "mediumFont")} style={{ whiteSpace: "nowrap" }}>{item.name.toLowerCase()[0].toUpperCase() + item.name.slice(1).toLowerCase()}</span>
                                        <span className={clsx(styles.formText, "mediumFont")} style={{ whiteSpace: "nowrap", display: "flex", flexDirection: "column", gap: "unset" }}>
                                            {
                                                item.subzone_name || item.zone_name ?
                                                    (item.subzone_name ? item.subzone_name : item.zone_name).map((data) => {
                                                        return (
                                                            <span>{" - " + (data.toLowerCase()[0].toUpperCase() + data.slice(1).toLowerCase()) + " " + (item.message.toLowerCase()[0].toUpperCase() + item.message.slice(1).toLowerCase())}</span>
                                                        )
                                                    })
                                                    :
                                                    <span>{" - " + (item.message.toLowerCase()[0].toUpperCase() + item.message.slice(1).toLowerCase())}</span>
                                            }
                                        </span>
                                    </div>
                                </>
                            )
                        })
                    }
                </div>
            </Box>
            {
                buttonEnable ?
                    <>
                        <div style={{ marginLeft: "13px" }}>
                            <span className="largeFont" style={{ margin: "0 0 10px 0", color: "#FFA222" }}> {confirmTitle} </span>
                        </div>
                        <div className={styles.bottomRow}>
                            <button className={clsx(styles.cancelBt, "regularFont")} onClick={handleClose}>
                                CANCEL
                            </button>
                            <span>
                                <button
                                    onClick={(e) => {
                                        handleClose();
                                        confirmButton(e);

                                    }}
                                    className={clsx(styles.submitBt, "regularFont")}
                                >
                                    YES
                                </button>
                            </span>
                        </div>
                    </> :
                    null
            }
        </div>
    </Modal>
);
FormModal.propTypes = {
    // confirmDelete: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    buttonEnable: PropTypes.bool,
    confirmButton: PropTypes.func,
    confirmTitle: PropTypes.string,
};
export default FormModal;
